import Payment from './Payment';
export default Payment;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/General/components/Payment/index.ts